module.exports = __webpack_public_path__ + "media/images/new_culture/bg-5-a4b41e195c46d89f6dadfb66ab58fd99.jpeg";